import type { MutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';

type PutChangePlaceCloudParams = {
  placeId: string;
  isCloud: boolean;
};

const putChangePlaceCloud = async ({
  placeId,
  isCloud,
}: PutChangePlaceCloudParams) =>
  apiClient
    .put(`/estabelecimentos/${placeId}/change-cloud-management`, {
      isCloud,
    })
    .then(response =>
      handleResponseSuccess(
        response,
        `Gestão nuvem ${isCloud ? 'ativada' : 'desativada'} com sucesso!`,
      )(),
    )
    .catch(
      handleResponseThrowError(
        'Não foi possível alterar o status da gestão nuvem.',
      ),
    );

export const usePutChangePlaceCloud = ({
  onSuccess,
  ...options
}: MutationOptions<unknown, unknown, PutChangePlaceCloudParams> = {}) => {
  return useMutation({
    mutationFn: putChangePlaceCloud,
    onSuccess: (...args) => {
      onSuccess?.(...args);
    },
    ...options,
  });
};
